import {
  Activity,
  Book,
  Calendar,
  Calendar1,
  Category,
  Grid1,
  Health,
  Home,
  Setting5,
  TaskSquare,
} from "iconsax-react";

const tele_menus = [
  {
    id: 1,
    title: "Dashboard",
    icon: <Category size={16} variant="Bold" />,
    isActive: true, // just to test how active link looks
    route: "/dashboard/telemedicine",
  },
  // {
  //     id: 2,
  //     title: "Account settings",
  //     icon: <Setting5 size={16} variant="Bold" />,
  //     route: "/dashboard/telemedicine/settings"
  // },
  {
    id: 3,
    title: "My calendar",
    icon: <Calendar size={16} variant="Bold" />,
    route: "/dashboard/telemedicine/calendar",
  },

  {
    id: 3.5,
    title: "Reschedule requests",
    icon: <Calendar size={16} variant="Bold" />,
    route: "/dashboard/telemedicine/reschedule",
  },
  {
    id: 4,
    title: "Meeting history",
    icon: <Book size={16} variant="Bold" />,
    route: "/dashboard/telemedicine/history",
  },
  {
    id: 5,
    title: "Consultations",
    icon: <Activity size={16} variant="Bold" />,
    route: "/dashboard/telemedicine/consultations",
  },
  {
    id: 5,
    title: "Prescriptions",
    icon: <TaskSquare size={16} variant="Bold" />,
    route: "/dashboard/telemedicine/prescriptions",
  },
  // {
  //     id: 5,
  //     title: "Health records",
  //     icon: <Health size={16} variant="Bold" />,
  //     route: "/dashboard/telemedicine/health_records"
  // },
  // {
  //     id: 6,
  //     title: "Care plans",
  //     icon: <Activity size={16} variant="Bold" />,
  //     route: "/dashboard/telemedicine/care_plans"
  // }
];

export default tele_menus;
